import {Alert, Box, Button, Container} from '@mui/material';
import {ArrowBackIosNew} from '@mui/icons-material';
import {useNavigate} from 'react-router-dom';
import {useParams} from 'react-router';
import {orderAPI} from '../../../services/OrderServices';
import {customerAPI} from '../../../services/CustomerServices';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';
import {OrderDetailsCardPanel} from '@mybake/ui/components/orders/order/OrderDetailsCardPanel';
import {OrderActionsGuid} from './OrderActionsGuid';
import {OrderDetailsContentGuid} from './OrderDetailsContentGuid';
import {getApiErrorMessage} from '../../../common/apiErrors';
import {ContentSkeleton} from '../../common/loading/ContentSkeleton';
import {InlineOrderGuidDto} from '@mybake/ui/models/Order/IOrderGuid';

export const OrdersDetailedCard = () => {
    const navigate = useNavigate();
    const {id = ''} = useParams();
    const {t} = useAppTranslation();
    const orderQuery = orderAPI.useGetOrderV2Query(id, {skip: !id});
    const customerQuery = customerAPI.useGetCustomerByIdV2Query(orderQuery.data?.customerId ?? '', {skip: !orderQuery.data?.customerId});
    const order = orderQuery.data;
    const customer = customerQuery.data;
    const inline: InlineOrderGuidDto | undefined = order && customer ? {
        id: order.id, description: order.description, orderNumber: order.orderNumber, customer, stage: order.stage,
        pickUpAt: order.pickUpAt, remainingToPay: order.remainingToPay, subOrders: order.subOrders, hasShortage: false, missingStock: [],
    } : undefined;
    return <Container maxWidth="lg" sx={{py: {xs: 2, sm: 4}}}>
        <Button variant="outlined" startIcon={<ArrowBackIosNew/>} onClick={() => navigate('/app/orders')} sx={{mb: 1.5}}>{t('orders:back_to_orders')}</Button>
        {(orderQuery.isLoading || customerQuery.isLoading) && <ContentSkeleton variant="details"/>}
        {orderQuery.error && <Alert severity="error" action={<Button onClick={() => orderQuery.refetch()}>{t('orders:retry')}</Button>}>{getApiErrorMessage(orderQuery.error, t)}</Alert>}
        {order && customer && inline && <OrderDetailsCardPanel orderNumber={order.orderNumber} stageLabel={order.stage}>
            <OrderDetailsContentGuid inlineOrder={inline} detailedOrder={order}/>
            <Box sx={{mt: 2}}><OrderActionsGuid order={order} customer={customer} onEdit={() => navigate('edit')}/></Box>
        </OrderDetailsCardPanel>}
    </Container>;
};
